module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-100italic.woff2?7f839a8652da29745ce4260846c3f88e";